import { render, staticRenderFns } from "./catchup.vue?vue&type=template&id=b53ef706&scoped=true"
import script from "./catchup.vue?vue&type=script&lang=js"
export * from "./catchup.vue?vue&type=script&lang=js"
import style0 from "./catchup.vue?vue&type=style&index=0&id=b53ef706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53ef706",
  null
  
)

export default component.exports